import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useDispatch, useSelector } from "react-redux";
import { useProperty } from "../../../PropertyContext";
import ReservationHeader from "../../Commun/ReservationHeader"
import ReservationSidebar from "../../Commun/ReservationSidebar"
import { deleteConnectivity, fetchConnectivity } from "../../../Redux/Slices/connectivitySlice";
import { useEffect, useState } from "react";
import { AddConectivity } from "./AddConectivity";
import swal from "sweetalert";
import { EditConnectivity } from "./EditConnectivity";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const Connectivity = () => {
    const { selectedProperty } = useProperty();
    const [selectedConnectivity, setSelectedConnectivity] = useState(null);
    const dispatch = useDispatch();

    const { connectivityList, loading } = useSelector((state) => state.connectivity);

    useEffect(() => {

        dispatch(fetchConnectivity(selectedProperty.PropertyID));

    }, [dispatch, selectedProperty]);

    const handleDelete = async (id) => {

        const willDelete = await swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });

        if (willDelete) {

            try {
                const resultAction = await dispatch(deleteConnectivity(id));

                if (deleteConnectivity.fulfilled.match(resultAction)) {
                    swal("Deleted!", "Connectivity deleted successfully.", "success");
                } else {
                    swal("Error!", "Something went wrong!", "error");
                }

            } catch (error) {
                swal("Error!", "Failed to delete!", "error");
            }
        }
    };

    return (
        <>
            {loading && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="card-title">CONNECTIVITY</h4>
                                                <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Connectivity">Add </button>
                                            </div>
                                        </div>
                                        {/* <div className="card-body">
                                            <div className="table-responsive">

                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>PlaceName</th>
                                                            <th>Distance</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {connectivityList && connectivityList.length > 0 ? (
                                                            connectivityList
                                                                .filter(item => item.IsActive)
                                                                .map((item) => (
                                                                    <tr key={item.ID}>
                                                                        <td>{item.PlaceName}</td>
                                                                        <td>{item.Distance}</td>
                                                                        <td>
                                                                            <button className="btn" data-bs-toggle="modal" data-bs-target="#Edit-Connectivity" onClick={() => setSelectedConnectivity(item)}><i className="fas fa-edit" ></i></button>
                                                                            <button className="btn text-danger" onClick={() => handleDelete(item.ID)}><i className="fas fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>


                                                </table>
                                            </div>
                                        </div> */}

                                        <div className="card-body">
                                            <DataTable
                                                value={connectivityList?.filter(item => item.IsActive)}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25]}
                                                stripedRows
                                                showGridlines
                                                responsiveLayout="scroll"
                                                emptyMessage="No Data Found"
                                                filterDisplay="menu"
                                            >

                                                {/* Place Name */}
                                                <Column
                                                    field="PlaceName"
                                                    header="Place Name"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Place"
                                                />

                                                {/* Distance */}
                                                <Column
                                                    field="Distance"
                                                    header="Distance"
                                                    sortable
                                                    filter
                                                    dataType="numeric"
                                                />

                                                {/* Action */}
                                                <Column
                                                    header="Action"
                                                    headerClassName="action-header-center"
                                                    body={(rowData) => (
                                                        <div className="d-flex gap-2">

                                                            <button
                                                                className="btn"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#Edit-Connectivity"
                                                                onClick={() => setSelectedConnectivity(rowData)}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>

                                                            <button
                                                                className="btn text-danger"
                                                                onClick={() => handleDelete(rowData.ID)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>

                                                        </div>
                                                    )}
                                                    style={{ width: "8rem" }}
                                                />

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Connectivity modal content */}
            <div id="Add-Connectivity" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Connecctivity</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <AddConectivity />
                        </div>
                    </div>
                </div>
            </div>
            {/* /.modal */}


            {/* Edit Connectivity modal content */}
            <div id="Edit-Connectivity" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Connecctivity</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <EditConnectivity connectivityData={selectedConnectivity} />
                        </div>
                    </div>
                </div>
            </div>
            {/* /.modal */}

        </>
    )
}
